import type { TranscodeUserContentRequestDto } from '@/data/dtos/userMedia/transcodeUserContentRequestDto';
import type { JsonObject } from '@/data/types/json';

export class TranscodeUserContentRequestRemapper {
  static toJson(dto: TranscodeUserContentRequestDto): JsonObject {
    return { ...dto } as JsonObject;
  }
}
